"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _UserAvatar = _interopRequireDefault(require("../User/UserAvatar"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var VotedUsers = function VotedUsers(_ref) {
  var votedUsers = _ref.votedUsers;
  return (0, _preact.h)("div", {
    className: "box__content widget box__pad idea_voted-users-widget"
  }, (0, _preact.h)("div", {
    className: "idea_voted-users-container"
  }, (0, _preact.h)("h3", {
    className: "widget-title"
  }, (0, _preact.h)(_phrase.default, {
    p: "idea.upvoted.by"
  }), " (", votedUsers.length, ")"), (0, _preact.h)("div", null, votedUsers.map(function (user) {
    return (0, _preact.h)(_UserAvatar.default, {
      user: user,
      extraClass: "voted-user-avatar avatar--responsive",
      showRank: true
    });
  }))));
};

var _default = VotedUsers;
exports.default = _default;